import React from 'react';
import classnames from 'classnames';
import './PortfolioPl.scss';
import useWidgetStream from 'widgets/streaming/useWidgetStream';
import { XAxisContextProvider } from 'utils/components/TimeSeriesChart/XAxisContext';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';
import { PortfolioPlChart } from './chart/PortfolioPlChart';
import styleConstants from 'styles/variables.module.scss';
import { usePortfolioPlData } from './portfolioPlData';
import PortfolioPlToolbar from 'widgets/portfolioPl/PortfolioPlToolbar';
import { useWidgetContext } from 'widgets/WidgetContext';

const padding = 2 * parseInt(styleConstants.spaceAround);
const borderWidth = 2 * parseInt(styleConstants.layoutBorderWidth);

export default function PortfolioPl() {
    const { widgetKey, width } = useWidgetContext();

    useWidgetStream();

    const { hasValidSelection } = useWidgetPortfolioSelectionStatus();

    const chartWidth = width - padding - borderWidth ?? 0;

    const data = usePortfolioPlData();
    const { timeDomain, breaksInTrading, rangeLabels, timeLineLabels } = data;

    return (
        <div className={classnames('PortfolioPl')} data-widget-id={widgetKey}>
            <div className="PortfolioPlContainer">
                <XAxisContextProvider
                    timeSeriesChartWidth={chartWidth}
                    startTime={timeDomain[0]}
                    endTime={timeDomain[1]}
                    breaks={breaksInTrading}
                    rangeLabels={rangeLabels}
                    timeLineLabels={timeLineLabels}
                >
                    <PortfolioPlToolbar width={chartWidth} />

                    {hasValidSelection && (
                        <PortfolioPlChart data={data} width={chartWidth} />
                    )}
                </XAxisContextProvider>
            </div>
        </div>
    );
}
